import React from 'react';

interface AritoActionBarProps {
  titleComponent: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  inForm?: boolean;
}

const extractTextFromNode = (node: React.ReactNode): string => {
  if (!node) return '';
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(extractTextFromNode).filter(Boolean).join(' ').trim();
  }
  if (React.isValidElement(node)) {
    const props = node.props as any;
    if (props && props.children) {
      return extractTextFromNode(props.children);
    }
  }
  return '';
};

export default function AritoActionBar({ titleComponent, className, children, inForm = false }: AritoActionBarProps) {
  React.useEffect(() => {
    const computedTitle = extractTextFromNode(titleComponent);
    if (computedTitle) {
      const originalTitle = document.title;
      document.title = computedTitle;
      return () => {
        document.title = originalTitle;
      };
    }
  }, [titleComponent]);

  return (
    <div
      className={`flex flex-col items-center justify-between gap-2 border-b border-gray-300 px-3 py-1 md:flex-row ${className}`}
    >
      {titleComponent}
      <div className='flex gap-2'>
        <div className={`grid lg:flex ${inForm ? 'grid-cols-2' : 'grid-cols-3'} gap-2`}>{children}</div>
      </div>
    </div>
  );
}
